
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { NotificationProvider, NotificationToast } from "./components/feature/NotificationCenter";

function App() {
  return (
    <NotificationProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <NotificationToast />
      </BrowserRouter>
    </NotificationProvider>
  );
}

export default App;
